import { styles, UserAssistanceTheme, variants } from '../UserAssistanceStyles.css';
import { baseTheme } from './UserAssistanceBaseTheme.css';
import { multiVariantStyles } from './UserAssistanceVariants.css';

/*******************
 * Component Theme
 *******************/

const UserAssistanceStableTheme: UserAssistanceTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { UserAssistanceStableTheme };
